import { TestIdDomain } from 'constants/testIds';

const scope = TestIdDomain.CONSTRUCTION;

export const ConstructionTestIds = {
  WRAPPER: `${scope}.wrapper`,
  SUMMARY_SECTION: `${scope}.summary-section`,
  SUMMARY_STAT: `${scope}.summary-stat`,
  BUDGET_SECTION: `${scope}.budget-section`,
  BUDGET_TABLE: `${scope}.budget-table`,
  BUDGET_EDIT_MENU: `${scope}.budget-edit-menu`,
  BUDGET_OVER_BUDGET_ALERT: `${scope}.budget-over-budget-alert`,
  DRAW_LIST_SECTION: `${scope}.draw-list-section`,
  DRAW_LIST_TABLE: `${scope}.draw-list-table`,
  DRAW_LIST_ADD_BUTTON: `${scope}.draw-list-add-button`,
  DRAW_LIST_EDIT_BUDGET_BUTTON: `${scope}.draw-list-edit-budget-button`,
  DRAW_REVIEW_OPEN_BUTTON: `${scope}.draw-review-open-button`,
  DRAW_ROW_REVIEW_BUTTON: `${scope}.draw-row-review-button`,
  BUDGET_EDIT_DRAWER: `${scope}.budget-edit-drawer`,
  BUDGET_EDIT_FIELD: `${scope}.budget-edit-field`,
  BUDGET_EDIT_SAVE_BUTTON: `${scope}.budget-edit-save-button`,
  BUDGET_CREATE_TYPE_FIELD: `${scope}.budget-create-type-field`,
  BUDGET_CREATE_CONTINGENCY_FIELD: `${scope}.budget-create-contingency-field`,
  BUDGET_CREATE_LINE_CATEGORY_FIELD: `${scope}.budget-create-line-category-field`,
  BUDGET_CREATE_LINE_DESCRIPTION_FIELD: `${scope}.budget-create-line-description-field`,
  BUDGET_CREATE_LINE_AMOUNT_FIELD: `${scope}.budget-create-line-amount-field`,
  BUDGET_CREATE_LINE_REMOVE_BUTTON: `${scope}.budget-create-line-remove-button`,
  BUDGET_CREATE_ADD_LINE_BUTTON: `${scope}.budget-create-add-line-button`,
  CREATE_DRAW_DRAWER: `${scope}.create-draw-drawer`,
  CREATE_DRAW_RETAINAGE_FIELD: `${scope}.create-draw-retainage-field`,
  CREATE_DRAW_LINE_AMOUNT_FIELD: `${scope}.create-draw-line-amount-field`,
  CREATE_DRAW_LINE_PERCENT_FIELD: `${scope}.create-draw-line-percent-field`,
  CREATE_DRAW_SAVE_BUTTON: `${scope}.create-draw-save-button`,
  CREATE_DRAW_OVER_REMAINING_ALERT: `${scope}.create-draw-over-remaining-alert`,
};
